import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getCompanyTeamMemberListData } from './mockData'

// post

const postCompanyTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getCompanyTeamMemberListData)
}

const patchCompanyTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getCompanyTeamMemberListData)
}

const deleteCompanyTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getCompanyTeamMemberListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/companyteammembers',
    handler: postCompanyTeamMember,
  },
  {
    method: 'patch',
    path: '/api/companyteammembers/:id',
    handler: patchCompanyTeamMember,
  },
  {
    method: 'delete',
    path: '/api/companyteammembers/:id',
    handler: deleteCompanyTeamMember,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
